export enum QuestionType {
    Boolean = 'BOOLEAN',
    Text = 'TEXT',
    Picklist = 'PICKLIST',
    Date = 'DATE',
    Physician = 'PHYSICIAN',
    Composite = 'COMPOSITE',
    Agreement = 'AGREEMENT',
    Numeric = 'NUMERIC',
    Decimal = 'DECIMAL',
    File = 'FILE',
    Matrix = 'MATRIX',
    ActivityInstanceSelect = 'ACTIVITY_INSTANCE_SELECT',
    Equation = 'EQUATION'
}
